import React from 'react';
import PropTypes from 'prop-types';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';

import {
  EditOutlined,
  ExpandMore
} from '@mui/icons-material';

import {
  accordionSummarySx,
  accordionSx,
  accordionTitleSx,
  editButtonSx,
  editIconSx,
  expandMoreIconSx,
  getAccordionDetailsSx,
  getTableSx,
  rowSx
} from './MHxSoapStyles';

const MHxSection = ({
  section,
  expanded,
  readOnly,
  onChange,
  onEdit
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      disableGutters
      elevation={0}
      square
      sx={accordionSx}>
      <AccordionSummary
        expandIcon={
          <ExpandMore sx={expandMoreIconSx} />
        }
        sx={accordionSummarySx}>
        <Typography sx={accordionTitleSx}>
          {section.title}
        </Typography>

        {!readOnly && section.editable && (
          <IconButton
            size="small"
            aria-label={`Edit ${section.title}`}
            onClick={event => {
              event.stopPropagation();
              onEdit(section);
            }}
            sx={editButtonSx}>
            <EditOutlined sx={editIconSx} />
          </IconButton>
        )}
      </AccordionSummary>

      <AccordionDetails
        sx={getAccordionDetailsSx(
          section.backgroundColor
        )}>
        <Table
          size="small"
          sx={getTableSx(
            section.backgroundColor
          )}>
          <TableBody>
            {section.rows.map((row, rowIndex) => (
              <TableRow
                key={`${section.title}-${rowIndex}`}
                sx={rowSx}>
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={`${cell}-${cellIndex}`}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};

MHxSection.propTypes = {
  section: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
};

export default MHxSection;